export const SHIPMENT_LINK_KEY = {
  onlineBooking: 'online_booking',
  tracking: 'tracking',
} as const

export type ShipmentLinkKey =
  (typeof SHIPMENT_LINK_KEY)[keyof typeof SHIPMENT_LINK_KEY]

/**
 * Stage-appropriate customer links come from the API (`shipment.links`) with
 * env-specific hosts — never build these URLs on the FE. An absent key means
 * the link does not apply to the shipment's stage.
 */
export function getShipmentLink(
  links: Record<string, string> | undefined,
  key: ShipmentLinkKey,
): string | undefined {
  return links?.[key]
}
